// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2NNKw","topBottomGutter":"Layout_topBottomGutter__eDS1v"};